import { RelativeDateDisplayMetric } from '@pushly/models/lib/enums/relative-date-display-metric'
import { AppMessageTemplateStyle } from '@pushly/models/lib/enums/app-messages/app-message-template-style'
import { AnimationType } from '@pushly/models/lib/enums/app-messages/app-message-animation-type'
import { AnimationEffect } from './types'

export const SESSION_METRICS_FILTERED = [RelativeDateDisplayMetric.SECONDS, RelativeDateDisplayMetric.MINUTES]
export const LIFETIME_METRICS = Object.values(RelativeDateDisplayMetric)

/** One day between showings, the platform's own default frequency cap. */
export const DEFAULT_REDISPLAY_INTERVAL_DAYS = 1

export const DEFAULT_TOGGLEABLE_FG_COLOR = '#111111'
export const DEFAULT_CTA_FG_COLOR = '#FFFFFF'

export const DEFAULT_TOGGLEABLE_BG_COLOR = '#FFFFFF'
export const DEFAULT_CTA_BG_COLOR = '#111111'

export const DEFAULT_IAM_ENTER_ANIMATIONS = [AnimationType.FADE]
export const DEFAULT_IAM_EXIT_ANIMATIONS = [AnimationType.FADE]
export const DEFAULT_IAM_ANIMATION_DURATION_MS = 200
export const ANIMATION_DISPLAY_NAME_MAP = {
    [AnimationEffect.Enter]: {
        [AnimationType.FADE]: 'Fade',
        [AnimationType.SLIDE_LEFT]: 'Slide from Right',
        [AnimationType.SLIDE_RIGHT]: 'Slide from Left',
        [AnimationType.SLIDE_DOWN]: 'Slide from Top',
        [AnimationType.SLIDE_UP]: 'Slide from Bottom',
        [AnimationType.ZOOM_IN]: 'Zoom In',
        [AnimationType.ZOOM_OUT]: 'Zoom Out',
    },
    [AnimationEffect.Exit]: {
        [AnimationType.FADE]: 'Fade',
        [AnimationType.SLIDE_LEFT]: 'Slide to Left',
        [AnimationType.SLIDE_RIGHT]: 'Slide to Right',
        [AnimationType.SLIDE_DOWN]: 'Slide to Bottom',
        [AnimationType.SLIDE_UP]: 'Slide to Top',
        [AnimationType.ZOOM_IN]: 'Zoom In',
        [AnimationType.ZOOM_OUT]: 'Zoom Out',
    },
}

/**
 * What creative shape each style's image frame wants, and why.
 *
 * The frame has no fixed aspect ratio outside of Banner. Modal sizes the image
 * to its own ratio against the card's width and caps the height, so a wide
 * creative is never cropped and a tall one is cropped to roughly a square.
 * Fullscreen gives the image every pixel the copy does not take, which is a tall
 * frame. Banner shows a fixed 48px square, which is why its uploads are cropped
 * to 1:1 on the way in.
 *
 * These come from the shared stylesheet in @pushly/rendering-utils, which both
 * the device renderer and this preview use; they are guidance for the author
 * rather than anything enforced here.
 */
export const APP_MESSAGE_IMAGE_GUIDANCE: Record<string, string> = {
    [AppMessageTemplateStyle.MODAL]:
        'JPG or PNG. A wide image works best — 1200 × 628 fills the frame uncropped. Taller images are cropped to about a square.',
    [AppMessageTemplateStyle.FULLSCREEN]:
        'JPG or PNG. A tall image works best — 1080 × 1920 fills the screen. Wide images are cropped in from the sides.',
    [AppMessageTemplateStyle.BANNER]:
        'JPG or PNG. Shown as a 48 × 48 square, so uploads are cropped to 1:1. A 144 × 144 source keeps it sharp.',
}
